import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useAuthStore } from '@/stores';
import api from '@/lib/api';

export const todayISO = () => new Date().toISOString().slice(0, 10);

// Payment date / receiving branch / bank account / reference for Receive Credit.
export function ReceiveCreditFields({ data, setData, branches }) {
  const { user } = useAuthStore();
  const [banks, setBanks] = useState([]);
  const canBackdate = ['admin', 'super_admin', 'accountant'].includes(user?.role) || user?.is_super_admin;
  useEffect(() => { api.get('/bank-accounts?active_only=true').then((r) => setBanks(r.data || [])).catch(() => {}); }, []);
  const set = (k) => (v) => setData((d) => ({ ...d, [k]: v }));
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label>Payment Received Date</Label>
        <Input type="date" value={data.payment_date || todayISO()} max={todayISO()} disabled={!canBackdate}
          onChange={(e) => set('payment_date')(e.target.value)} data-testid="receive-payment-date" />
        {!canBackdate && <p className="text-[11px] text-muted-foreground mt-1">Earlier dates: admins and accountants only</p>}
      </div>
      <div>
        <Label>Receiving Branch</Label>
        <Select value={data.received_by_branch_id || 'owner'} onValueChange={(v) => set('received_by_branch_id')(v === 'owner' ? '' : v)}>
          <SelectTrigger data-testid="receive-branch-select"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="owner">Sale's own branch</SelectItem>{branches.map((b) => <SelectItem key={b.id} value={b.id}>{b.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {data.payment_mode === 'bank' && (
        <>
          <div>
            <Label>Bank Account</Label>
            <Select value={data.bank_account_id || ''} onValueChange={set('bank_account_id')}>
              <SelectTrigger data-testid="receive-bank-account-select"><SelectValue placeholder="Select account" /></SelectTrigger>
              <SelectContent>{banks.map((b) => <SelectItem key={b.id} value={b.id}>{b.name || b.bank_name}{b.account_number ? ` · ${String(b.account_number).slice(-4)}` : ''}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Bank Reference</Label>
            <Input value={data.reference || ''} onChange={(e) => set('reference')(e.target.value)} placeholder="Transfer ref" data-testid="receive-bank-reference" />
          </div>
        </>
      )}
    </div>
  );
}
